import { Select } from '@/components/Select';
import { type ListingDefaults, type AppType, PLAY_CATEGORIES } from '@/lib/play-template';
import { Field, Group, SectionTitle, inputCls } from './controls';

interface Props { value: ListingDefaults; appType: AppType; onChange: (v: ListingDefaults) => void }

export function StoreSettingsSection({ value, appType, onChange }: Props) {
  const set = <K extends keyof ListingDefaults>(k: K, v: ListingDefaults[K]) => onChange({ ...value, [k]: v });
  const categories = PLAY_CATEGORIES.filter((c) => c.type === appType);
  const notes = value.release_notes.length;

  return (
    <div className="space-y-4">
      <SectionTitle sub="Grow users → Store presence → Store settings, plus the release notes of the first draft. The app type above decides which categories are offered.">
        Store settings
      </SectionTitle>

      <Group title="App category">
        <Field label={`${appType === 'game' ? 'Game' : 'App'} category`} hint="Shown on the store listing and used for ranking.">
          <Select
            searchable
            value={value.category}
            onChange={(v) => set('category', v)}
            options={categories.map((c) => ({ value: c.id, label: c.label }))}
            placeholder="Pick a category"
          />
        </Field>
      </Group>

      <Group title="Contact details">
        <p className="text-sm text-content-muted mb-3">The public contact email comes from the publishing account. Set it in the account settings before publishing.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Field label="Website" hint="Optional.">
            <input className={inputCls} type="url" value={value.website} onChange={(e) => set('website', e.target.value)} placeholder="https://" />
          </Field>
          <Field label="Phone" hint="Optional.">
            <input className={inputCls} type="tel" value={value.phone} onChange={(e) => set('phone', e.target.value)} placeholder="+1 …" />
          </Field>
        </div>
      </Group>

      <Group title="First release">
        <Field
          label="Release notes"
          hint={<span className={notes > 500 ? 'text-red-400' : ''}>{notes} / 500 · written into the "What's new" of the first draft.</span>}
        >
          <textarea className={`${inputCls} h-20`} value={value.release_notes} onChange={(e) => set('release_notes', e.target.value)} />
        </Field>
      </Group>
    </div>
  );
}
